import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../_components/Loading';

import { Path } from '../_components/Path';
import { apiConstants } from '../_constants';
import { courseService } from '../_services/course.service';
import { isEnglish } from '../_helpers';
import { SubjectsList } from './SubjectsList';

export const Course = () => {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [courseData, setCourseData] = useState(null);

  useEffect(() => {
    getCourseWithSubjects(id);
  }, []);
  const getCourseWithSubjects = (course_id) => {
    if (course_id) {
      setIsLoading(true);
      courseService.getCourseWithSubjects({ course_id: course_id }).then(
        (res) => {
          setIsLoading(false);
          setCourseData(res.data);
        },
        (err) => {
          console.log(err, 'this is error data');
          setIsLoading(false);
        },
      );
    }
  };
  return (
    <div>
      <div className='container'>
        <Path
          pathList={[
            { name: 'Course List', link: 'courselist' },
            { name: 'Subject', id: 2 },
          ]}
        />
        {!isLoading && (
          <div
            className={
              'coursedetails ' + (isEnglish(courseData?.course_name) ? 'ltrtext' : 'rtltext')
            }
            style={{ flexDirection: isEnglish(courseData?.course_name) ? 'row' : 'row-reverse' }}
          >
            <img
              src={
                courseData?.image
                  ? apiConstants.imgUrl + courseData?.image
                  : '/img/course_dummy.png'
              }
              alt=''
              className='courseicon'
            />
            <div className='coursedesc '>
              <div
                className={
                  'coursenamehead ' + (isEnglish(courseData?.course_name) ? 'ltrtext' : 'rtltext')
                }
              >
                {courseData?.course_name}
              </div>
              <div
                className={
                  'coursedesc d-flex flex-wrap ' +
                  (isEnglish(courseData?.course_name)
                    ? 'justify-content-start'
                    : 'justify-content-end')
                }
                style={{ gap: '10px' }}
              >
                <div className='descitem'>
                  <img src='/img/subjects.png' className='desc_icon' /> {courseData?.count_subjects}{' '}
                  Subjects
                </div>
                <div className='descitem'>
                  <img src='/img/book_icon.png' className='desc_icon' /> {courseData?.topicCount}{' '}
                  Topics
                </div>
                <div className='descitem'>
                  <img src='/img/question_icon.png' className='desc_icon' />{' '}
                  {courseData?.total_questions} Questions
                </div>
              </div>
            </div>
          </div>
        )}
        {!isLoading && <SubjectsList subjects={courseData?.Subjects} />}
        {isLoading && <Loading />}
      </div>
    </div>
  );
};
